import { render } from "./CoverageConfigModal.vue?vue&type=template&id=cbf2270e&scoped=true"
import script from "./CoverageConfigModal.vue?vue&type=script&lang=js"
export * from "./CoverageConfigModal.vue?vue&type=script&lang=js"

import "./CoverageConfigModal.vue?vue&type=style&index=0&id=cbf2270e&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbf2270e"]])

export default __exports__